import { createDynamicThunk } from ".";

export const getBlockedDateThunk = createDynamicThunk({
  typePrefix: "expenseCalendarControls/getBlockedDateThunk",
  endpoint: "/expCal",
  method: "POST",
  useHandleSearch: false,
});

export const blockDateThunk = createDynamicThunk({
  typePrefix: "expenseCalendarControls/blockDateThunk",
  endpoint: "/manage-expense-calendar",
  method: "POST",
  refreshList: true,
  listThunk: getBlockedDateThunk,
});

export const unblockDateThunk = createDynamicThunk({
  typePrefix: "expenseCalendarControls/unblockDateThunk",
  endpoint: "/manage-expense-calendar",
  method: "POST",
  refreshList: true,
  listThunk: getBlockedDateThunk,
});
